module.exports = __webpack_public_path__ + "img/Ma.b67bd0c6.png";